import React from "react";
import styles from "./style.module.scss";

interface IProps {
  type?: string;
  label: string;
  value: string;
  placeholder: string;
  labelClassName? :string,
  height?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Input = ({
  type,
  placeholder,
  label,
  value,
  height,
  labelClassName,
  onChange,
}: IProps) => {
  return (
    <div className={styles.customInput}>
      <label htmlFor="" className={labelClassName ? labelClassName : ""}>{label}</label>
      <input
        style={{
          height: `${height}`,
        }}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        type={type ? type : "text"}
      />
    </div>
  );
};

export default Input;
